<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/userManagement/user')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Role</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="user_role_id" v-model="addData.user_role_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in optRole" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('user_role_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>First Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.first_name" name="first_name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('first_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Last Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.last_name" name="last_name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('last_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Email</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.email" name="email" v-validate="'required|email'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('email') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Staff</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="staff_status" v-model="addData.is_staff">
                    <option :value="null">Please select</option>
                    <option :value="1">Yes</option>
                    <option :value="0">No</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('staff_status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Password</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input ref="password" v-model="addData.password" name="password" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('password') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Confirm Password</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="confirm_password" name="confirm_password" v-validate="'required|confirmed:password'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('confirm_password') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'addSales',
  data: function () {
    return {
      dataBranch: [],
      addData: {
        employee_id: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        resign_date: null,
        is_staff: null,
        user_role_id: null
      },
      confirm_password: '',
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      file: null,
      optRole: [],
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.post('vendor/v1/user/', this.addData).then(response => {
            this.$router.push('/userManagement/user')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('vendor/v1/user_role?sorting=name&sorting_type=asc').then(response => {
        let arr_role = response.data.data.rows
        let filter = arr_role.filter(function(item) {
          return item.name !== "superadmin"
        })
        this.optRole = filter
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
